export default __webpack_public_path__ + "img/markup_tools/color_selection.svg";